const isBrowser = () => typeof window !== 'undefined' && window.localStorage;

const ApiLocalStorage = {
  TEMP_REMEMBER_ME: 'tempRememperMe',

  setItem: (key, value) => {
    if (!isBrowser()) return;
    if (value) {
      if (typeof value === 'object') {
        localStorage.setItem(key, JSON.stringify(value));
      } else {
        localStorage.setItem(key, value);
      }
    }
  },

  getItem: (key) => {
    if (!isBrowser()) return null;
    const obj = localStorage.getItem(key);
    if (obj) {
      try {
        return JSON.parse(obj);
      } catch {
        return obj;
      }
    }
    return null;
  },

  removeItem: (key) => {
    if (!isBrowser()) return;
    localStorage.removeItem(key);
  },
};

export default ApiLocalStorage;
